export default class ConversationFeedback {
    /**
     * @constructor
     * @param {string} quote 
     * @param {string} feedback 
     */
    constructor(quote, feedback) {
        this._quote = quote;
        this._feedback = feedback;
    }

    get quote() {
        return this._quote;
    }

    get feedback() {
        return this._feedback;
    }

    toObject() {
        return {
            quote: this._quote,
            feedback: this._feedback,
        };
    }

    static fromObject(json) {
        return new ConversationFeedback(json.quote, json.feedback);
    }
}